import { FC, useEffect } from 'react';
import { PickUpDetails, Transfer } from 'ts/transfer/interfaces/TransferResultsResponse';
import { Position } from 'ts/transfer/interfaces/Transfer';
import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet';
import RoutingMachine from './RoutingOSM';
import { useTranslation } from 'react-i18next';
import Leaflet from 'leaflet';
import L from 'leaflet';
import withErrorBoundary from 'components/shared/withErrorBoundary';
import { imgWaypointA, imgWaypointB } from 'constants/generic';

interface TransferResultOSMMapProps {
  transfer: Transfer;
  center: Position;
  mapData: {
    pickup: Position;
    dropoff: Position;
  };
  getLocalName: (item: PickUpDetails) => string;
  onChangeDirection: (distance: string) => void;
}

const TransferResultOSMMap: FC<TransferResultOSMMapProps> = ({ mapData, ...props }) => {
  const [t] = useTranslation();
  
  useEffect(() => {
    setTimeout(() => {
      const distance = sessionStorage.getItem('transferDistance');
      if (distance) {
        props.onChangeDirection(`${Math.floor(+distance / 1000)} ${t('km')}`);
      }
    }, 1000);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const iconA = new Leaflet.Icon({
    iconUrl: imgWaypointA,
    iconSize: [16, 28],
    className: 'map-osm-marker',
  });

  const iconB = new Leaflet.Icon({
    iconUrl: imgWaypointB,
    iconSize: [16, 28],
    className: 'map-osm-marker',
  });

  return (
    <MapContainer className="w100p h100p">
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />

      {mapData.dropoff && (
        <Marker zIndexOffset={200} position={mapData.dropoff} icon={iconA}>
          <Popup className="map-transfer">
            <div>{props.getLocalName(props.transfer.pickUpDetails)}</div>
          </Popup>
        </Marker>
      )}
      {mapData.pickup && (
        <Marker zIndexOffset={20} position={mapData.pickup} icon={iconB}>
          <Popup className="map-transfer">
            <div>{props.getLocalName(props.transfer.dropOffDetails)}</div>
          </Popup>
        </Marker>
      )}
      {mapData.dropoff && mapData.pickup && !!(L as any).Routing && (
        <RoutingMachine from={mapData.pickup} to={mapData.dropoff} />
      )}
    </MapContainer>
  );
};

export default withErrorBoundary(TransferResultOSMMap, 'TransferResultOSMMap');
